import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 3.333c-.736 0-1.333.597-1.333 1.334v6.666a2.667 2.667 0 1 1-5.334 0v-4a.667.667 0 0 1 1.334 0v4a1.333 1.333 0 1 0 2.666 0V4.667a2.667 2.667 0 1 1 5.334 0V8a.667.667 0 0 1-1.334 0V4.667c0-.737-.597-1.334-1.333-1.334",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.576 2.32a.667.667 0 0 0-1.152 0L2.251 4.33a.667.667 0 0 0 .576 1.003h2.346a.667.667 0 0 0 .575-1.002zM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
    }, null, -1)
  ])))
}
export default { render: render }